import { z } from "zod";
import { PaginationRequestSchema, PaginationResponseSchema } from "./pagination";

export const SubCategoryQuerySchema = PaginationRequestSchema.extend({
  disciplineId: z.string().optional(),
  category: z.string().optional(),
  createdFrom: z.string().optional(),
  createdTo: z.string().optional(),
});
export type SubCategoryQueryDTO = z.infer<typeof SubCategoryQuerySchema>;

export const CreateSubCategoryRequestSchema = z.object({
  disciplineId: z.string().min(1, "La disciplina es requerida"),
  category: z.string().min(1, "El nombre de la categoría es requerido"),
  externalId: z.string().optional(),
  description: z.string().optional(),
});

export const UpdateSubCategoryRequestSchema = CreateSubCategoryRequestSchema.partial();

export type CreateSubCategoryRequestDTO = z.infer<typeof CreateSubCategoryRequestSchema>;
export type UpdateSubCategoryRequestDTO = z.infer<typeof UpdateSubCategoryRequestSchema>;

export const SubCategoryResponseSchema = z.object({
  id: z.string(),
  disciplineId: z.string(),
  disciplineName: z.string().nullable(),
  category: z.string(),
  externalId: z.string().nullable(),
  description: z.string().nullable(),
  createdAt: z.coerce.date(),
  updatedAt: z.coerce.date(),
});
export type SubCategoryResponseDTO = z.infer<typeof SubCategoryResponseSchema>;

export const SubCategoriesPaginatedResponseSchema = PaginationResponseSchema(SubCategoryResponseSchema);
export type SubCategoriesPaginatedResponseDTO = z.infer<typeof SubCategoriesPaginatedResponseSchema>;
